import { useSettings } from "~/store/settings";

const formatNumber = (
	number: number,
	mode: "number" | "currency" | "odds" = "number",
	showSymbol = true,
	notation: "standard" | "scientific" | "engineering" | "compact" | undefined = undefined,
	useGrouping: boolean = false
) => {
	const settings = useSettings();
	try {
		switch (mode) {
			case "currency":
				return `${showSymbol ? `${settings.config?.appSetting?.CurrencySymbol} ` : ""}${Intl.NumberFormat(
					settings.config ? settings.config.cultures[0].cultureCode : "en-US",
					{
						notation: notation ?? "standard",
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}
				).format(number)}`;
			case "number":
				return Intl.NumberFormat("en-US", {
					useGrouping: useGrouping,
					notation: notation ?? "compact",
					maximumFractionDigits: 1,
				}).format(number);
			case "odds":
				return Intl.NumberFormat("en-US", {
					notation: notation ?? "standard",
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
					roundingMode: "floor",
				}).format(number);
		}
	} catch (e) {
		return number;
	}
};

export default formatNumber;
